/**
 * FikoKesmeParametre — CNC Kesme Parametreleri (Speeds & Feeds) motoru
 * Malzeme + takım çapı/ağız → devir (RPM) + ilerleme (mm/dk) + talaş debisi (MRR).
 * n = Vc·1000/(π·D) ,  Vf = n·z·fz
 */

/** Malzeme kesme hızı Vc (m/dk) ve diş başına ilerleme fz (mm) — karbür takım, orta. Düzenlenebilir. */
export interface KesmeMalzeme { ad: string; vc: number; fz: number; }

export const KESME_MALZEMELERI: KesmeMalzeme[] = [
  { ad: 'Alüminyum',       vc: 400, fz: 0.10 },
  { ad: 'Pirinç',          vc: 250, fz: 0.08 },
  { ad: 'Bronz',           vc: 180, fz: 0.07 },
  { ad: 'Bakır',           vc: 200, fz: 0.08 },
  { ad: 'Yumuşak Çelik',   vc: 120, fz: 0.06 },
  { ad: 'Alaşımlı Çelik',  vc: 90,  fz: 0.05 },
  { ad: 'Paslanmaz Çelik', vc: 70,  fz: 0.04 },
  { ad: 'Döküm Demir',     vc: 110, fz: 0.10 },
  { ad: 'Titanyum',        vc: 40,  fz: 0.03 },
  { ad: 'Plastik',         vc: 500, fz: 0.12 },
];

export interface KesmeGirdi {
  capMm: number;      // takım çapı D
  agizSayisi: number; // z (flute)
  vc: number;         // kesme hızı (m/dk)
  fz: number;         // diş başına ilerleme (mm)
  kesmeDerinlik: number; // ap (mm) — MRR için
  kesmeGenislik: number; // ae (mm) — MRR için
}

export interface KesmeSonuc {
  devirRpm: number;     // n
  ilerlemeMmDk: number; // Vf
  fnMmDev: number;      // devir başına ilerleme (fn = z·fz)
  mrrCm3Dk: number;     // talaş debisi (ap·ae·Vf / 1000)
}

export function kesmeHesapla(g: KesmeGirdi): KesmeSonuc {
  const D = Math.max(0.1, g.capMm || 1);
  const z = Math.max(1, Math.round(g.agizSayisi || 1));
  const n = (g.vc * 1000) / (Math.PI * D);
  const fn = z * (g.fz || 0);
  const vf = n * fn;
  const mrr = (Math.max(0, g.kesmeDerinlik || 0) * Math.max(0, g.kesmeGenislik || 0) * vf) / 1000;
  return { devirRpm: n, ilerlemeMmDk: vf, fnMmDev: fn, mrrCm3Dk: mrr };
}
